import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/offcanvas';

import { documentReady } from './lib/utils';
import {
	initMegaNav,
	initTablesOfContents,
	initDrawerLinks,
	initFooterAccordions,
	initStickyCta,
	initCarousels,
	initDropdownNavs,
	initMobileNav,
	initSiteSearchBox,
	initTabLists,
	initVideoPlayers,
	initIFrameResizer,
	initSfFormAddons
} from './components';

const main = () => {
	initMegaNav();
	initTablesOfContents();
	initIFrameResizer();
	initDrawerLinks();
	initFooterAccordions();
	initStickyCta();
	initCarousels();
	initDropdownNavs();
	initSiteSearchBox();
	initTabLists();
	initVideoPlayers();
	initMobileNav();
	initSfFormAddons();
};

void documentReady
	.then(main);
